import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { resetPassword } from '../../../api/users';

import LoadingButton from '../../../components/LoadingButton';
import ReusableModal from '../../../components/ReusableModal/ReusableModal';
import useNotify from '../../../hooks/useNotify';
import PortalSessionContext from '../../../contexts/PortalSessionContext/PortalSessionContext';

const ResetPasswordModal = (props: Props) => {
	const { logout } = React.useContext(PortalSessionContext);
	const notify = useNotify();
	const history = useHistory();
	const state = history.location.state as { email: string; attempts: number };
	const email = state.email;
	const zeroAttempts = state.attempts === 0;

	const onMessageConfirmed = () => {
		if (email) {
			resetPassword(email);
			logout();
			notify({
				type: 'success',
				title: 'Success',
				message: 'We have sent you an email to reset your password.',
				timeout: 5000,
			});
		} else {
			notify({
				type: 'error',
				title: 'Email not found',
				message:
					'Something went wrong, and we cannot retrieve your email. Try manually resetting your password through the forgot password form.',
				timeout: 5000,
			});
		}
		props.onClose();
	};

	return (
		<ReusableModal title="Reset Password">
			<MessageSection>
				<p>
					{zeroAttempts
						? 'Your account has been locked due to multiple failed login attempts. You can reopen your account by resetting your password and completing two-factor authentication.'
						: 'You recently attempted to login to PlayUp with your email address and a weak password that no longer meets our minimum password criteria. To prevent against account takeovers, we’re requiring you to reset your password before allowing access to the console.'}
				</p>

				<HighlightedMessageText>
					Please click below to send an email to complete the password reset.
				</HighlightedMessageText>
			</MessageSection>
			<StyledButton onClick={onMessageConfirmed}>Reset Password</StyledButton>
		</ReusableModal>
	);
};

export default ResetPasswordModal;

interface Props {
	onClose: () => void;
	smallScreen?: boolean | undefined;
	showRG?: boolean;
}

const MessageSection = styled.section`
	margin-top: 1rem;
	margin-bottom: 1rem;
	padding: 1rem;
	color: #191d22;
	background-color: #efefef;
	line-height: 20px;
`;

const HighlightedMessageText = styled.p`
	margin-top: 1rem;
	text-align: center;
	font-weight: 600;
`;

const StyledButton = styled(LoadingButton)`
	height: 50px;
	line-height: 50px;
	width: 100%;
	text-align: center;
	font-weight: 600;
	color: #ffffff;
	background-color: #000000;
	border-radius: 5px;

	&:hover {
		background-color: #2d3134;
	}
`;
